import { useEffect, useState } from "react";
import { DataGrid, Tooltip, Icon } from "../../../components";
import { history, NfseService } from "../../../services";
import { PermisoesHelper } from "../../../helpers";
import { ListLayout } from "../../../layouts";
import { formatPrice, responseErros } from "../../../utils";
import {
  FormFiltroAvancado,
  MenuSuperiorLista,
  BaixarXmlDialog,
  ImportarOrdemServicoDialog,
} from "./components";

const nfseService = new NfseService();
const permissoesHelper = new PermisoesHelper();

const ListNfse = () => {
  permissoesHelper.validarPermisao("ordem-servicos-visualizar");
  const [nfseList, setNfseLista] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openBaixarXmlDialog, setOpenBaixarXmlDialog] = useState(false);
  const [openImportarOrdemServicoDialog, setOpenImportarOrdemServicoDialog] =
    useState(false);
  const status = [
    {
      nome: "ENVIADA",
      label: "Enviada",
      cor: "#4FBB53",
    },
    {
      nome: "PENDENTE",
      label: "Pendente",
      cor: "#EA9D2B",
    },
    {
      nome: "CANCELADA",
      label: "Cancelada",
      cor: "#DC3545",
    },
  ];
  const colunas = [
    {
      field: "status",
      headerName: "Status",
      flex: 100,
      renderCell: (params) => obterIconeStatus(params.value),
    },
    { field: "serieDocumento", headerName: "Série", width: 100 },
    { field: "numeroDocumento", headerName: "Nº Documento", width: 150 },
    { field: "clienteNome", headerName: "Cliente", flex: 400 },
    {
      field: "totalServicos",
      headerName: "Total Serviços",
      width: 200,
      sortable: false,
      valueGetter: (params) => formatPrice(getTotalServicos(params.row)),
    },
  ];
  const buttonSelectOpcoes = [
    {
      permission: permissoesHelper.temPermisao("ordem-servicos-cadastrar"),
      descricao: "Importar Ordem de Serviço",
    },
  ];

  useEffect(() => {
    buscarNfse();
  }, []);

  const getTotalServicos = (row) => {
    if (row?.totalServicos || row.totalServicos > 0) {
      return row.totalServicos;
    }
    return row.servicos.reduce(
      (total, servico) => total + (servico.valor || 0),
      0,
    );
  };

  async function buscarNfse(filtro) {
    setLoading(true);
    const result = await nfseService.getAllFiltroAvancado(filtro);
    setLoading(false);
    if (!result.isAxiosError) {
      setNfseLista(result?.data?.rows || []);
      setRowsCount(result?.data?.count || 0);
    } else {
      responseErros(result);
    }
  }

  function obterIconeStatus(status) {
    switch (status) {
      case "PENDENTE":
        return (
          <Tooltip title="Pendente" arrow placement="right">
            <Icon>
              <i
                className="ph-fill ph-circle"
                style={{ color: "#EA9D2B", fontSize: 18 }}
              ></i>
            </Icon>
          </Tooltip>
        );
      case "ENVIADA":
        return (
          <Tooltip title="Enviada" arrow placement="right">
            <Icon>
              <i
                className="ph-fill ph-circle"
                style={{ color: "#4FBB53", fontSize: 18 }}
              ></i>
            </Icon>
          </Tooltip>
        );
      case "CANCELADA":
        return (
          <Tooltip title="Cancelada" arrow placement="right">
            <Icon>
              <i
                className="ph-fill ph-circle"
                style={{ color: "#DC3545", fontSize: 18 }}
              ></i>
            </Icon>
          </Tooltip>
        );
    }
  }

  const onClickCadastrarOrcamentoServico = (descricao) => {
    if (descricao === "Importar Ordem de Serviço") {
      setOpenImportarOrdemServicoDialog(true);
      return;
    }
    history.push("/faturamento/nfse/create");
  };

  const onClickEditar = (id) => {
    history.push(`/faturamento/nfse/${id}`);
  };

  const sendServerDatagrid = (props) => {
    buscarNfse(props.filtros);
  };

  return (
    <ListLayout
      title="NFS-e"
      onClickCadastrar={onClickCadastrarOrcamentoServico}
      permissaoButton={true}
      buttonSelectOpcoes={buttonSelectOpcoes}
      loading={loading}
      ButtonMenu={
        <MenuSuperiorLista setOpenBaixarXmlDialog={setOpenBaixarXmlDialog} />
      }
    >
      <DataGrid
        rows={nfseList}
        columns={colunas}
        rowCount={rowsCount}
        paginationMode="server"
        listaStatus={status}
        FormFiltroAvancado={FormFiltroAvancado}
        sendServer={sendServerDatagrid}
        visualizarShow={permissoesHelper.temPermisao(
          "ordem-servicos-visualizar",
        )}
        editShow={permissoesHelper.temPermisao("ordem-servicos-visualizar")}
        onClickEdit={onClickEditar}
      />
      <BaixarXmlDialog
        openBaixarXmlDialog={openBaixarXmlDialog}
        setOpenBaixarXmlDialog={setOpenBaixarXmlDialog}
      />
      <ImportarOrdemServicoDialog
        openImportarOrdemServicoDialog={openImportarOrdemServicoDialog}
        setOpenImportarOrdemServicoDialog={setOpenImportarOrdemServicoDialog}
        setLoading={setLoading}
      />
    </ListLayout>
  );
};

export default ListNfse;
